import React from 'react'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import currentUserHasAccess from '../../../../util/widget-helper'
import { CREATE_IPR_APPOINTMENT } from '../../ui-definition/process-ui'

const CreateIprAppointment = ({ customer }) => {
    if (!currentUserHasAccess(CREATE_IPR_APPOINTMENT) || !customer) {
        return null
    }

    return (
        <ContentBox title="Create IPR Appointment">
            <Row>
                <Column size={12}>
                    {customer.storeIprBookingUrl && (
                        <a
                            href={customer.storeIprBookingUrl}
                            className="btn btn-danger btn-sm"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Create IPR Appointment&#160;
                            <i className="fa fa-external-link" />
                        </a>
                    )}
                </Column>
            </Row>
        </ContentBox>
    )
}

export default CreateIprAppointment



// WEBPACK FOOTER //
// ./src/modules/process/component/task-detail/CreateIprAppointment.js